var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046:45544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.167883 10.0003C0.249018 9.49171 0.727091 9.14525 1.23565 9.22639C1.74421 9.30752 2.09067 9.7856 2.00953 10.2942C2.00866 10.2997 2.00773 10.3052 2.00674 10.3108C1.05715 15.9007 4.81891 21.202 10.4089 22.1516C15.9988 23.1012 21.3002 19.3395 22.2497 13.7495C23.1993 8.15955 19.4375 2.85824 13.8476 1.90865C10.4099 1.32469 6.9108 2.5255 4.55611 5.09731L7.30608 5.74635C7.79476 5.90895 8.05903 6.43685 7.89649 6.92552C7.73389 7.41419 7.20582 7.67886 6.71715 7.51631L2.50279 6.37855C2.12186 6.25168 1.86491 5.89518 1.86496 5.49365V1.05249C1.86496 0.537484 2.28244 0.120003 2.79745 0.120003C3.31246 0.120003 3.72994 0.537484 3.72994 1.05249V3.30511C8.53209 -1.26232 16.1277 -1.07201 20.6951 3.73013C25.2625 8.53228 25.0723 16.1278 20.2701 20.6953C15.4679 25.2628 7.87235 25.0725 3.30486 20.2703C0.700375 17.5319 -0.461973 13.7266 0.167883 10.0003Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1046:45544)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75743 7.75175C3.99525 11.5211 6.67416 17.989 12 17.9944C17.3256 17.9894 20.0048 11.5215 16.2427 7.75185C14.0094 5.42402 9.99077 5.42439 7.75743 7.75175ZM14.183 13.5145L12.7021 12.0335C12.7151 11.8148 12.6218 11.6058 12.4685 11.4701L12.4688 11.4554V8.71318C12.444 8.09124 11.5558 8.09171 11.5313 8.71318V11.4554L11.5315 11.4701C11.0413 11.9089 11.3738 12.7307 12.0391 12.6965L13.5201 14.1774C13.7032 14.3605 14 14.3605 14.183 14.1774C14.3661 13.9944 14.3661 13.6976 14.183 13.5145Z",
    fill: "#8A8A8A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046:45544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0.000244141)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1046:45544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6.00024)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.643ed0fb.svg";
export { ForwardRef as ReactComponent };